
/* tslint:disable */
/* eslint:disable */
// prettier-ignore
// ReSharper disable RedundantEmptyConstructor
// ReSharper disable InconsistentNaming
/* 
   This file is automatically generated, all manual changes to this file will be lost.

   Generated with command: dotnet entitygen generate -i INPUT_PATH -o OUTPUT_PATH -n Helsenorge.Helseregistre.InternalApi.Entities -l TypeScript
 */
// ------ Enum members ------
export enum DirekteInnsynType
{
    Ukjent = "Ukjent",
    Innhold = "Innhold",
    LoggOverBruk = "LoggOverBruk",
    LoggUtlevering = "LoggUtlevering"
}
export enum ErrorMelding
{
    Ingen = "Ingen",
    DyplenkeFeil = "DyplenkeFeil"
}
export enum FunksjonType
{
    EnkelFunksjon = "EnkelFunksjon",
    RadioFunksjon = "RadioFunksjon"
}
export enum InfoMelding
{
    Ingen = "Ingen",
    RegistreIkkeKomplett = "RegistreIkkeKomplett"
}
export enum InkluderingType
{
    Inkludert = "Inkludert",
    Deltager = "Deltager",
    Oppfort = "Oppfort"
}
export enum OppforingsType
{
    Ukjent = "Ukjent",
    SentraleHelseRegistre = "SentraleHelseRegistre",
    ForskningsprosjektHelseundersokelser = "ForskningsprosjektHelseundersokelser",
    NasjonaleKvalitetsRegistre = "NasjonaleKvalitetsRegistre",
    BehandlingsrettedeRegistre = "BehandlingsrettedeRegistre"
}
export enum RegisterDialogType
{
    Unknown = "Unknown",
    RegisterInnsynOpplysninger = "RegisterInnsynOpplysninger",
    RegisterInnsynUtlevering = "RegisterInnsynUtlevering",
    RegisterMeldeFeil = "RegisterMeldeFeil",
    RegisterLoggOverBruk = "RegisterLoggOverBruk"
}
export enum ScopeType
{
    Selvbetjeningsfunksjon = "Selvbetjeningsfunksjon",
    Register = "Register"
}
export enum VedleggType
{
    Vedlegg = "Vedlegg",
    Integrert = "Integrert",
    Lenke = "Lenke"
}
export enum WarnMelding
{
    Ingen = "Ingen",
    RegisterSvarerIkke = "RegisterSvarerIkke"
}
// ReSharper restore RedundantEmptyConstructor
// ReSharper restore InconsistentNaming
/* tslint:enable */